import * as THREE from "three";
import Experience from "../Experience.js";
import gsap from 'gsap'

export default class iPhone {
  constructor() {
    this.experience = new Experience();
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;
    this.scene = this.experience.scene;
    this.world = this.experience.world;
    this.camera = this.experience.camera;
    this.sizes = this.experience.sizes;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    if (this.debug) {
      this.debugFolder = this.debug.addFolder({
        title: "iPhone",
        expanded: false,
      });
    }

    this.hover = false;
    this.mouse = new THREE.Vector2();

    this.raycaster = new THREE.Raycaster();

    this.setModel();
    this.setColorEvent();

    window.addEventListener("mousemove", (event) => {
      this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
      this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1;
    });
  }

  setColorEvent() {

    const pacificblue = document.querySelector("#colornav-default-pacific-blue");
    pacificblue.addEventListener("click", (event) => {
      gsap.to(this.model.border.material.color, {
        r: 0.1046165004372596,
        g: 0.16202937066555023,
        b: 0.20507878065109253,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      gsap.to(this.model.cameras.material.color, {
        r: 0.061246056109666824,
        g: 0.13013650476932526,
        b: 0.18447501957416534,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      // this.model.border.material.color.r = 0.1046165004372596;
      // this.model.border.material.color.g = 0.16202937066555023;
      // this.model.border.material.color.b = 0.20507878065109253;
      // this.model.cameras.material.color.r = 0.061246056109666824;
      // this.model.cameras.material.color.g = 0.13013650476932526;
      // this.model.cameras.material.color.b = 0.18447501957416534;
    });

    const silver = document.querySelector("#colornav-default-silver");
    silver.addEventListener("click", (event) => {
      gsap.to(this.model.border.material.color, {
        r: 0.6038275361061096,
        g: 0.6104958057403564,
        b: 0.5775806307792664,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      gsap.to(this.model.cameras.material.color, {
        r: 0.597201943397522,
        g: 0.6038275361061096,
        b: 0.5711249709129333,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      // this.model.border.material.color.r = 0.6038275361061096;
      // this.model.border.material.color.g = 0.6104958057403564;
      // this.model.border.material.color.b = 0.5775806307792664;
      // this.model.cameras.material.color.r = 0.597201943397522;
      // this.model.cameras.material.color.g = 0.6038275361061096;
      // this.model.cameras.material.color.b = 0.5711249709129333;
    });

    const gold = document.querySelector("#colornav-default-gold");
    gold.addEventListener("click", (event) => {
      gsap.to(this.model.border.material.color, {
        r: 0.9911022186279297,
        g: 0.8387991189956665,
        b: 0.6795427799224854,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      gsap.to(this.model.cameras.material.color, {
        r: 0.6938719749450684,
        g: 0.5271153450012207,
        b: 0.38642948865890503,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      // this.model.border.material.color.r = 0.9911022186279297;
      // this.model.border.material.color.g = 0.8387991189956665;
      // this.model.border.material.color.b = 0.6795427799224854;
      // this.model.cameras.material.color.r = 0.6938719749450684;
      // this.model.cameras.material.color.g = 0.5271153450012207;
      // this.model.cameras.material.color.b = 0.38642948865890503;
    });
    
    const graphite = document.querySelector("#colornav-default-graphite");
    graphite.addEventListener("click", (event) => {
      gsap.to(this.model.border.material.color, {
        r: 0.09530749171972275,
        g: 0.09305897355079651,
        b: 0.08437623083591461,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      gsap.to(this.model.cameras.material.color, {
        r: 0.06662595272064209,
        g: 0.06480327248573303,
        b: 0.05951124429702759,
        duration: 1,
        delay: 0,
        ease: 'power3.inOut'
      });
      // this.model.border.material.color.r = 0.09530749171972275;
      // this.model.border.material.color.g = 0.09305897355079651;
      // this.model.border.material.color.b = 0.08437623083591461;
      // this.model.cameras.material.color.r = 0.06662595272064209;
      // this.model.cameras.material.color.g = 0.06480327248573303;
      // this.model.cameras.material.color.b = 0.05951124429702759;
    });
  }

  setModel() {
    this.model = {};

    this.model.group = this.resources.items.iPhone.scene;

    this.model.group.scale.set(1.0, 1.0, 1.0);
    this.model.group.rotation.y = Math.PI * 0.5;
    this.scene.add(this.model.group);
    this.scene.traverse(child => {

      if (child.name === "border") {
        this.model.border = child;
      }
      if (child.name === "Cube_4") {
        this.model.cameras = child;
      }
    })

    if (this.debug) {
      this.debugFolder
        .addInput(this.model.border.material, "color", {
          view: "color",
        })
        .on("change", () => {
          this.model.border.material.color.set(this.model.color);
          this.model.border.material.needsUpdate = true
        });
    }
  }

  update() {
    //this.camera.modes.debug.instance.position.copy( this.setCameraPosition() );

    this.raycaster.setFromCamera(this.mouse, this.camera.instance);

    // create an array containing all objects in the scene with which the ray intersects
    const intersects = this.raycaster.intersectObjects(
      this.model.group.children
    );

    if (intersects.length > 0) {
      if (!this.hover) {
        this.hover = true;
      }
      if (this.hover)
        this.model.group.rotation.y =
          Math.PI * 0.5 + Math.sin(this.time.elapsed * 0.005) * 0.05;
    } // there are no intersections
    else {
      if (this.hover) {
        this.hover = false;
        this.model.group.rotation.y = Math.PI * 0.5;
      }
    }
  }
}
